import moment from 'moment';

export class DateHelper {

    public static GetFirstDayOfWeek(iWeekStartDate: any, dayInWeek: any): Date {
        return moment(iWeekStartDate).weekday(dayInWeek).toDate();
    }

    public static GetDisplayDatestring(date: string | number | Date, withtime: any): any {

        if (date && date != '') {

            if (date instanceof Date) {  // d.valueOf() could also work
                // date is valid
            }
            else {
                date = new Date(date);
            }

            let options: Intl.DateTimeFormatOptions = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };

            if (!withtime) {
                delete options.hour;
                delete options.minute;
                delete options.hour12;
            }

            return new Intl
                .DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale, options)
                .format(date);
        }
        else {

            return '';
        }

    }

    public static GetJsonDate(date: any) {

        return '\/Date(' + this.GetUTCFromDate(date) + ')\/';
    }

    public static SetTimeToDate(dateval: string | number | Date, hour: number, minute: number, seconds: number) {

        let date = new Date(dateval);
        let newval = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        newval.setHours(hour);
        newval.setMinutes(minute);
        newval.setSeconds(seconds);

        return newval;
    }

    public static GetUTCFromDate(date: any) {

        var str = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), 0);

        return str;
    }

    public static GetDateDiffInDays(date1: any, date2: any) {

        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        return diffDays;
    }

    public static GetDateDiffInminutes(date2: any, date1: any) {

        var diff = (date2.getTime() - date1.getTime()) / 1000;
        diff /= 60;

        return Math.abs(Math.round(diff));
    }

    public static GetDateStringIn_yyyy_mm_dd_format(today: any) {

        return moment(today).format('YYYY-MM-DD');
    }

    public static GetDateStringInZeroHours(today: any) {

        return moment(moment(today).format('YYYY-MM-DD')).toDate();
    }
}